import React, {useContext, useEffect, useState} from "react";
import './CitySelector.css'
import arrow from '../../../imgs/city_selector_arrow.png'
import {AppContext} from "../../../App";
import {ICity} from "../../model/B2CInfo";

interface ICitySelectorProps {
    city: ICity
    onSelected: (city: ICity) => void
}

export default function CitySelector(props: ICitySelectorProps) {
    const appContext = useContext(AppContext);
    const [opened, setOpened] = useState<boolean>(false);

    useEffect(() => {
        document.onclick = (e) => {
            if (opened) {
                setOpened(false)
            }
        }
    }, [opened])

    let cities = appContext?.b2cInfo.cities ?? []

    let divs = cities.map((city) => {
       return <div className={`City_selector_item ${props.city === city ? "City_selector_item_selected" : ""}`} onClick={(e) => {
           setOpened(false)
           props.onSelected(city)
       }}>{city.name}</div>
    })

    return <div className="City_selector_container">
        <button className="City_selector_button" onClick={(e) => setOpened(true)}>
            {props.city.name}
            <img src={arrow}/>
        </button>
        {opened && <div className="City_selector_list">
            <button className="City_selector_button" onClick={(e) => setOpened(false)}>
                {props.city.name}
                <img className="City_selector_list__arrow" src={arrow}/>
            </button>
            {divs}
        </div>}
    </div>;
}